import { render, staticRenderFns } from "./PagePasswordRecovery.vue?vue&type=template&id=1ea88917&"
import script from "./PagePasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./PagePasswordRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports